<template>
    <div>
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                v-if="isClicked === true"></span>
        </div>

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" data-toggle="modal" data-target="#myModalclose">
                        <div class="icon-24 icon-x-blue"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Akun Anda</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <main class="content-wrapper main-page w-limit">
            <div class="p-y-16 p-x-20 f-16">
                Sepertinya Anda sudah pernah mendaftar dengan nomor ini. Pilih akun untuk login atau klik tambah akun
                untuk mendaftar akun baru
            </div>
            <div class="separator-line"></div>
            <div class="account-wrapper">
                <div v-for="owner in owners" :key="owner.idowner" class="account-item">
                    <div v-on:click="signIn(owner.idowner)" class="p-x-20 p-y-20 b-d flex-align-center">
                        <div class="flex-1">
                            <div class="f-16 f-semi m-d-2">{{owner.nama}}</div>
                            <div class="f-14 f-c-midgrey" v-if="owner.email !== ''">
                                {{ owner.email }}
                            </div>
                            <div class="f-14 f-c-midgrey" v-else>
                                <i>Email belum diset</i>
                            </div>
                        </div>
                        <div class="icon-24 icon-right-grey"></div>
                    </div>
                </div>
            </div>
            <div class="p-x-20 p-y-20 flex-align-center b-d" @click="goaddregis">
                <div class="icon-24 icon-plus-circle"></div>
                <div class="flex-1 f-16 f-c-blue m-l-8">Tambah Akun Baru</div>
            </div>

        </main>

        <!-- MODALs -->
        <div class="modal fade" id="myModalclose" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <div class="f-16 f-bold">Keluar Smartlink Owner</div>
                        <div class="modal-head--right" data-dismiss="modal">
                            <div class="icon-24 icon-x-blue"></div>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">

                        <div class="m-t-16 f-16">
                            Apakah anda yakin ingin keluar dari Smartlink Owner?
                        </div>

                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button type="button" class="btn smart-secondary" data-dismiss="modal" @click="cancel">Ya,
                                Keluar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "AkunRegister",
        mounted() {
            this.getOTP();
        },
        data() {
            return {
                owners: [],
                isClicked: false,
            }
        },
        methods: {
            cancel() {
                var myItem = localStorage.getItem('incontext-device');
                localStorage.clear();
                localStorage.setItem('incontext-device',myItem);
                this.$router.push('/startscreen')
            },
            async getOTP() {
                this.isClicked = true;
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/auth/loginwa?telp=' + telp)
                    this.owners = res.data.data;
                    this.isClicked = false;
                    $('#loadingPage').removeClass('overlayLoading');

                } catch (e) {
                	this.$catch_error_response(e)
	                
	                this.isClicked = false;
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#textbtn').show();
	                $('#nextbutton').prop('disabled', false);
                }
            },
            async signIn(key) {
                this.isClicked = true;
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var telp = localStorage.getItem("telp")
                    var super_owner_key = localStorage.getItem("super_owner_key");
                    const dataForm = new FormData;
                    const appUserAgent = navigator.userAgent
                    dataForm.append('user_agent', appUserAgent)
                    dataForm.append('idowner', key);
                    dataForm.append('telp', telp);
                    dataForm.append("super_owner_key", super_owner_key)
                    const res = await this.$axios.post(this.$baseurl + '/auth/subakunsign', dataForm)
                    if (res.status === 200) {
                        localStorage.removeItem("super_owner_key");
                        localStorage.setItem("token", res.data.data.token)
                        localStorage.setItem("idowner", res.data.data.idowner)
                        this.$router.push('/successregis')
                    }
                    this.isClicked = false;
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                	this.$catch_error_response(e)
	
	                this.isClicked = false;
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#textbtn').show();
	                $('#nextbutton').prop('disabled', false);
                }
            },
            goaddregis() {
                this.$router.push('/flowregis1')
            },
        },
    }
</script>

<style scoped>
    .add-account {
        text-align: center;
    }

    .overlayLoading {
        position: fixed;
        display: inline;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: white;
        z-index: 9999;
    }

    .spinner-border-sm {
        width: 2rem;
        height: 2rem;
        border-width: .3em;
        top: 40% !important;
        text-align: center;
        margin-top: 70%;
        margin-left: 45%;
        color: #007bff;
    }
</style>